<div class="ticket-details">
    <h2 *ngIf="ticket.value.id !== 0 || editMode" class="title-header">
        <div class="title-left">
            <a
                class="link"
                [href]="appBaseUrl + 'tickets/' + ticket.value.id"
                (click)="copyOnly($event, appBaseUrl + 'tickets/' + ticket.value.id)"
                [title]="appBaseUrl + 'tickets/' + ticket.value.id"
                >
                <span class="material-icons-outlined">link</span>
            </a>
        </div>
        <div class="header-buttons">
            <ng-container *ngIf="editMode; else viewModeButtons">
                <action-button
                    class="btn-save"
                    (actionEvent)="saveTicket($event)"
                    icon="save"
                    ></action-button>
            </ng-container>
            <button
                *ngIf="isCreating"
                class="btn-cancel"
                (click)="cancelTicket($event)"
                type="button">
                <span class="material-icons-outlined">cancel</span>
            </button>

            <ng-template #viewModeButtons>
                <button class="btn-edit" (click)="toggleEditMode()">
                    <span class="material-icons-outlined">edit</span>
                </button>
                <!-- a trashcan, though this archives: it says the ticket goes
                     away, which is what the user is deciding. The tooltip says
                     where it goes, and its twin says it can come back. A
                     ticket the series has planned for a later day can do
                     neither before that day, and the tooltip then says when. -->
                <button *ngIf="!ticket.value.archived"
                        class="btn-archive" (click)="archiveTicket()"
                        [disabled]="notYetActive"
                        [title]="(notYetActive ? 'ticketDetails.notYetActive.archive' : 'ticketDetails.archive') | translate: { date: activeFromText }">
                    <span class="material-icons-outlined">delete</span>
                </button>
                <button *ngIf="ticket.value.archived"
                        class="btn-archive" (click)="activateTicket()"
                        [disabled]="notYetActive"
                        [title]="(notYetActive ? 'ticketDetails.notYetActive.archive' : 'ticketDetails.activate') | translate: { date: activeFromText }">
                    <span class="material-icons-outlined">restore_from_trash</span>
                </button>
            </ng-template>
        </div>
    </h2>

    <div class="form-messages">
        <messages
            [form]="ticketForm"
            [messagesObserver]="messages"
            [showNonFieldKeys]="TRUE"
            [showFieldName]="TRUE"
            [showFieldKeys]="FALSE">
        </messages>
    </div>

    <empty-details *ngIf="TicketEmpty()" what="empty.what.ticket"></empty-details>

    <div *ngIf="ticket.value.id !== 0 || editMode" class="ticket-info-container">
        <div *ngIf="ticket.value.id !== 0 && !editMode" class="ticket-info">
            <table>
                <tr class="text-row">
                    <td>
                        <strong class="label">
                            {{ "ticketDetails.titleLabel" | translate }}:
                        </strong>
                    </td>
                    <td>
                        <span class="span">{{ ticket.value.title }}</span>
                    </td>
                </tr>
                <tr class="text-row" *ngIf="hasValue(ticket.value.description)">
                    <td>
                        <strong class="label">
                            {{ "ticketDetails.descriptionLabel" | translate }}:
                        </strong>
                    </td>
                    <td>
                        <span class="span" [innerHtml]="sanitizeHtml(ticket.value.description)"></span>
                    </td>
                </tr>
                <tr class="registered">
                    <td>
                        <strong class="label">
                            {{ "ticketDetails.registeredLabel" | translate }}:
                        </strong>
                    </td>
                    <td>
                <dependent-choice
                    class="reg"
                    [topic]="'users'"
                    [reduced]="true"
                    [selectedId]="ticket.value.registeredBy"
                    [choiceObserver]="assignedIdObserver"
                    [labelOnDemand]="assignedLabelerByService">
                </dependent-choice>
                </td>
                </tr>
                <tr>
                    <td>
                        <strong class="label">
                            {{ "ticketDetails.departmentIdLabel" | translate }}:
                        </strong>
                    </td>
                    <td>
                <dependent-choice
                    class="dep"
                    [topic]="'departments'"
                    [reduced]="true"
                    [selectedId]="ticket.value.departmentId"
                    [choiceObserver]="departmentIdObserver"
                    [labelOnDemand]="departmentLabelerByService">
                </dependent-choice>
                </td>
                </tr>
                <tr *ngIf="hasValue(assignedLabel)">
                    <td>
                        <strong class="label">
                            {{ "ticketDetails.assignedLabel" | translate }}:
                        </strong>
                    </td>
                    <td>
                <dependent-choice
                    class="usr"
                    [topic]="'users'"
                    [reduced]="true"
                    [selectedId]="ticket.value.assigned"
                    [choiceObserver]="assignedIdObserver"
                    [labelOnDemand]="assignedLabelerByService">
                </dependent-choice>
                </td>
                </tr>
                <tr *ngIf="hasValue(statusLabel)">
                    <td>
                        <strong class="label">
                            {{ "ticketDetails.statusLabel" | translate }}:
                        </strong>
                    </td>
                    <td>
                <dependent-choice
                    class="sts"
                    [topic]="'status'"
                    [reduced]="true"
                    [selectedId]="ticket.value.statusId"
                    [choiceObserver]="statusIdObserver"
                    [labelOnDemand]="statusLabelerByService">
                </dependent-choice>
                </td>
                </tr>
                <tr *ngIf="recurrence" class="recurrence-info">
                    <td>
                        <strong class="label">
                            {{ "recurrence.label" | translate }}:
                        </strong>
                    </td>
                    <td>
                        <div class="not-yet-active" *ngIf="notYetActive" role="note">
                            <span class="material-icons-outlined">lock_clock</span>
                            <span>{{ "ticketDetails.notYetActive.label" | translate: { date: activeFromText } }}</span>
                        </div>
                        <div class="recurrence-summary">
                            <span class="material-icons-outlined">repeat</span>
                            <span class="describe">{{ recurrence.description }}</span>
                        </div>
                        <div class="recurrence-position" *ngIf="recurrence.sequence">
                            {{ "recurrence.details.occurrence" | translate }}
                            {{ recurrence.sequence }}
                            <ng-container *ngIf="!recurrence.unbounded">
                                {{ "recurrence.details.of" | translate }} {{ recurrence.total }}
                            </ng-container>
                            <ng-container *ngIf="recurrence.unbounded">
                                ({{ "recurrence.details.unbounded" | translate }})
                            </ng-container>
                        </div>
                        <div class="recurrence-next" *ngIf="recurrence.active && recurrence.next">
                            {{ "recurrence.details.next" | translate }}: {{ recurrence.next }}
                        </div>
                        <div class="recurrence-ended" *ngIf="!recurrence.active">
                            {{ "recurrence.details.endedOn" | translate }}
                            {{ recurrence.pattern.cancelledAt }}
                        </div>
                    </td>
                </tr>
                <tr *ngIf="hasValue(priorityLabel)">
                    <td>
                        <strong class="label">
                            {{ "ticketDetails.priorityLabel" | translate }}:
                        </strong>
                    </td>
                    <td>
                <dependent-choice
                    class="prio"
                    [topic]="'priority'"
                    [reduced]="true"
                    [selectedId]="ticket.value.priorityId"
                    [choiceObserver]="priorityIdObserver"
                    [labelOnDemand]="priorityLabelerByService">
                </dependent-choice>
                </td>
                </tr>
                <tr *ngIf="hasValue(branchLabel)">
                    <td>
                        <strong class="label">
                            {{ "ticketDetails.branchIdLabel" | translate }}:
                        </strong>
                    </td>
                    <td>
                <dependent-choice
                    class="dc"
                    [topic]="'branches'"
                    [reduced]="true"
                    [selectedId]="ticket.value.branchId"
                    [choiceObserver]="branchIdObserver"
                    [labelOnDemand]="branchLabelerByService">
                </dependent-choice>
                </td>
                </tr>
            </table>

            <div class="tab-header">
                <div
                    class="tab"
                    *ngFor="let tab of tabs; let i = index"
                    [class.active]="i === selectedIndex"
                    (click)="onTabChange(i)"
                    >
                    {{ tab.label }}
                </div>
            </div>

            <div class="tab-content">
                <div
                    class="tab-pane"
                    *ngFor="let tab of tabs; let i = index"
                    [@tabSlide]="getDirection(i)"
                    [ngClass]="{
                    active: selectedIndex === i
                    }"
                    >
                    <ng-container *ngIf="selectedIndex === i">
                        <ng-container [ngSwitch]="i">


                            <ng-container *ngSwitchCase="0">
                                <comments
                                    #commentsComp
                                    class="comments"
                                    [currentTicket]="ticket"
                                    ></comments>
                            </ng-container>

                            <ng-container *ngSwitchCase="1">
                                <media-list [currentTicket]="ticket"></media-list>
                            </ng-container>

                            <ng-container *ngSwitchCase="2">
                                <involved [currentTicket]="ticket"></involved>
                            </ng-container>
                            <ng-container *ngSwitchCase="3">


                                <ticket-timeline
                                    [items]="items"
                                    [events]="ticket.value.parts.timeline || []"
                                    [createdAt]="ticket.value.created"
                                    [createdBy]="ticket.value.registeredBy"
                                    [referenceLabeler]="statusLabelerByService"
                                    ></ticket-timeline>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
            <messages
                class="message"
                [form]="ticketForm"
                [messagesObserver]="messages"
                [showNonFieldKeys]="TRUE"
                [showFieldName]="TRUE"
                [showFieldKeys]="FALSE"
                ></messages>
        </div>

        <form [formGroup]="ticketForm" *ngIf="editMode" class="ticket-form">
            <div class="form-group">
                <label class="lbt" for="title"
                       >{{ "ticketDetails.titleLabel" | translate }}:</label
                >
                <input type="text" id="title" formControlName="title" [readonly]="notYetActive" />
                <messages
                    class="message"
                    [form]="ticketForm"
                    [messagesObserver]="messages"
                    fieldname="title"
                    ></messages>
            </div>

            <div class="form-group">
                <label class="descrption" for="description"
                       >{{ "ticketDetails.descriptionLabel" | translate }}:</label
                >
                <div class="editor-container" [class.locked]="notYetActive">
                    <p-editor
                        id="description"
                        formControlName="description"
                        [readonly]="notYetActive"
                        [modules]="{ toolbar: false }"
                        ></p-editor>
                </div>

                <messages
                    class="message"
                    [form]="ticketForm"
                    [messagesObserver]="messages"
                    fieldname="description"
                    ></messages>
            </div>

            <table>
                <tr>
                    <td>
                        <strong class="label">
                            {{ "ticketDetails.departmentIdLabel" | translate }}:
                        </strong>
                    </td>
                    <td>
                <single-choice
                    formControlName="departmentId"
                    [locked]="notYetActive"
                    [topic]="'departments'"
                    [editMode]="editMode"
                    [ticketId]="ticketId"
                    (choiceEvent)="relaySingleChoice($event)"
                    [labeler]="departmentLabeler"
                    [choiceObserver]="departmentIdObserver"
                    [labelOnDemand]="departmentLabelerByService">
                </single-choice>

                <messages
                    class="message"
                    [form]="ticketForm"
                    [messagesObserver]="messages"
                    fieldname="departments">
                </messages>
                </td>
                </tr>

                <tr>
                    <td>
                        <strong class="label">
                            {{ "ticketDetails.assignedLabel" | translate }}:
                        </strong>
                    </td>
                    <td>
                <single-choice
                    formControlName="assigned"
                    [topic]="'users'"
                    [editMode]="editMode"
                    [ticketId]="ticketId"
                    (choiceEvent)="relaySingleChoice($event)"
                    [labeler]="assignedLabeler"
                    [choiceObserver]="assignedIdObserver"
                    [labelOnDemand]="assignedLabelerByService">
                </single-choice>

                <messages
                    class="message"
                    [form]="ticketForm"
                    [messagesObserver]="messages"
                    fieldname="assigned">
                </messages>
                </td>
                </tr>

                <tr *ngIf="!isCreating">
                    <td>
                        <strong class="label">
                            {{ "ticketDetails.statusLabel" | translate }}:
                        </strong>
                    </td>
                    <td>
                <single-choice
                    formControlName="statusId"
                    [locked]="notYetActive"
                    [topic]="'status'"
                    [editMode]="editMode"
                    [ticketId]="ticketId"
                    (choiceEvent)="relaySingleChoice($event)"
                    [choiceObserver]="statusIdObserver"
                    [labeler]="statusLabeler"
                    [labelOnDemand]="statusLabelerByService">
                </single-choice>

                <messages
                    class="message"
                    [form]="ticketForm"
                    [messagesObserver]="messages"
                    fieldname="statusId">
                </messages>
                </td>
                </tr>

                <tr>
                    <td>
                        <strong class="label">
                            {{ "ticketDetails.branchIdLabel" | translate }}:
                        </strong>
                    </td>
                    <td>
                <single-choice
                    formControlName="branchId"
                    [locked]="notYetActive"
                    [topic]="'branches'"
                    [editMode]="editMode"
                    [ticketId]="ticketId"
                    (choiceEvent)="relaySingleChoice($event)"
                    [labeler]="branchLabeler"
                    [choiceObserver]="branchIdObserver"
                    [labelOnDemand]="branchLabelerByService">
                </single-choice>

                <messages
                    class="message"
                    [form]="ticketForm"
                    [messagesObserver]="messages"
                    fieldname="branchId">
                </messages>
                </td>
                </tr>

                <!-- the same pill as the choosers, but it switches between two
                     values rather than opening a list, so the thing on the right
                     is a switch and not a caret -->
                <tr class="priority">
                    <td>
                        <strong class="label">
                            {{ "ticketDetails.priorityLabel" | translate }}:
                        </strong>
                    </td>

                    <td>
                        <label class="pill-toggle" [class.locked]="notYetActive" [style.--choice-color]="priorityColour">
                            <!-- the filled flag, and only for the high priority:
                                 the same one the chip in the list shows -->
                            <span *ngIf="priorityIsHigh" class="pill-icon material-icons">flag</span>

                            <!-- the priority's own word, out of the row the
                                 save will store, so the form cannot name one
                                 priority and write another -->
                            <span class="pill-value">{{ prioritySwitchLabel }}</span>

                            <input
                                type="checkbox"
                                [checked]="priorityIsHigh"
                                [disabled]="notYetActive"
                                (change)="onPriorityToggle($event)"
                                />
                            <span class="slider"></span>
                        </label>

                <messages
                    class="message"
                    [form]="ticketForm"
                    [messagesObserver]="messages"
                    fieldname="priorityId">
                </messages>
                </td>
                </tr>


                <!-- said beside the recurrence, because that is where the
                     reason lies: the series planned this ticket for later -->
                <tr *ngIf="notYetActive" class="not-yet-active-row">
                    <td colspan="2">
                        <div class="not-yet-active" role="note">
                            <span class="material-icons-outlined">lock_clock</span>
                            <span>{{ "ticketDetails.notYetActive.label" | translate: { date: activeFromText } }}</span>
                        </div>
                    </td>
                </tr>

                <tr class="recurrence">
                    <td>
                        <strong class="label">
                            {{ "recurrence.label" | translate }}:
                        </strong>
                    </td>
                    <td>
                        <div class="recurrence-toggle-wrapper">
                            <label class="toggle-container">
                                <input
                                    type="checkbox"
                                    [checked]="ticketForm.value.hasRecurrence"
                                    (change)="onRecurrenceToggle($event)"
                                    />
                                <span class="slider"></span>
                            </label>
                        </div>
                    </td>
                </tr>

                <tr *ngIf="ticketForm.value.hasRecurrence" class="recurrence-subform">
                    <!-- over beide kolommen: het subformulier zet zijn eigen
                         label/waarde-rijen neer, met dezelfde 32% labelkolom -->
                    <td colspan="2">
                        <recurrence-form formControlName="recurrence"></recurrence-form>

                <messages
                    class="message"
                    [form]="ticketForm"
                    [messagesObserver]="messages"
                    fieldname="recurrence">
                </messages>
                    </td>
                </tr>
            </table>
            <messages
                class="message"
                [form]="ticketForm"
                [messagesObserver]="messages"
                [showNonFieldKeys]="TRUE"
                [showFieldName]="TRUE"
                [showFieldKeys]="FALSE"
                ></messages>
        </form>
    </div>
</div>
